import { styled } from '@mui/system';
import Link from '@mui/material/Link';
import NoteCardInfo from '../../NoteCard/NoteCardInfo';
import { DEFAULT_AVATAR } from '../../../../utils/constant';

const PictureFrame = styled('div')(({ imgURL, theme }) => ({
  backgroundImage: `url(${imgURL})`,
  backgroundSize: 'cover',
  width: '300px',
  height: '320px',
  [theme.breakpoints.down(740)]: {
    width: '100%',
    height: '216px',
  },
}));

const InnerYellowFrame = styled('div')(({ theme }) => ({
  width: 'calc(100% - 16px)',
  height: 'calc(100% - 16px)',
  border: '1px solid #AB9178',
  padding: '12px',
  display: 'flex',
  alignItems: 'flex-end',
  [theme.breakpoints.down(740)]: {
    width: '100%',
    height: '100%',
    padding: '11px',
  },
}));

const ShadowLayer = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(180.23deg, rgba(77, 67, 67, 0) 62.73%, rgba(0, 0, 0, 0.94) 84.74%);',
});

const NoteCard = (props) => {
  const imgURL = () => {
    const defaultImg = props.author.avatar || DEFAULT_AVATAR;
    if (
      props.attachments == undefined ||
      props.attachments == null ||
      props.attachments.length <= 0
    ) {
      //return default img: authors avatar
      return defaultImg;
    } else {
      return props.attachments[0].url;
    }
  };
  const linkUrl = `/note/${props._id}`;

  return (
    <Link href={linkUrl} underline="none">
      <PictureFrame imgURL={imgURL()}>
        <ShadowLayer>
          <InnerYellowFrame>
            <NoteCardInfo
              title={props.title}
              author={props.author.userName}
              numberLikes={props.likedUsers.length}
            />
          </InnerYellowFrame>
        </ShadowLayer>
      </PictureFrame>
    </Link>
  );
};

export default NoteCard;
